import { useEffect, useState } from 'react';
import { Api } from '../../componentes/Api';
import { Card,Row,Col, CardBody, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter } from "reactstrap"
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
import Moment from "moment";
import ReactInputMask from 'react-input-mask';
import Autosuggest from 'react-autosuggest';


const modeloDatos = {
    ordenID: 0,
    descripcion:"",
    placa:"",
    fechaSalida: new Date,  
    creadoPor: "",
    modificadoPor: "",
    fechaCreado: new Date,
    fechaModificado: new Date
   
}
const modeloDatos1 = {
    ordenLineaID: 0,
    ordenID: 0,
    clienteID: 0,
    telefono: "",
    no_Invoice: "",
    id: "",
    direccion: "",
    nombreCliente: "",
    descripcion: "",
    monto:0,
    fechaSalida: new Date,
    creadoPor: "",
    modificadoPor: "",
    fechaCreado: new Date,
    fechaModificado: new Date

}
const modeloDatos2 = {
    ResumenID: 0,
    ordenID: 0,
    articuloID: 0,
    cantidad: 0,
    descripcion: "",
    creadoPor: "",
    modificadoPor: "",
    fechaCreado: new Date,
    fechaModificado: new Date

}
const modeloDatos3 = {
    articuloID: 0,
    descripcion: "",
    creadoPor: "",
    modificadoPor: "",
    fechaCreado: new Date,
    fechaModificado: new Date

}

const Version = () => {
    const [tabla, setTabla] = useState(modeloDatos);
    const [tabla1, setTabla1] = useState(modeloDatos1);
    const [tabla2, setTabla2] = useState(modeloDatos2);
    const [tabla3, setTabla3] = useState(modeloDatos3);
    const [Listado, SetListado] = useState([]);
    const [Listado1, SetListado1] = useState([]);
    const [Listado2, SetListado2] = useState([]);
    const [pendiente, setPendiente] = useState(true);
    const [verModal, setVerModal] = useState(false);
    const [verModal1, setVerModal1] = useState(false);
    const [verModal2, setVerModal2] = useState(false);
    const [verModal3, setVerModal3] = useState(false);
    const [Controlfecha, setControlfecha] = useState();
    const [user, setUser] = useState(window.localStorage.getItem("sesion_usuario"))

    const [a_Productos, setA_Productos] = useState([])
    const [a_Busqueda, setA_Busqueda] = useState("")

    const handleChange = (e) => {
        let value = e.target.nodeName === "SELECT" ? (e.target.value == "true" ? true : false) : e.target.value;
        setTabla({
            ...tabla,
            [e.target.name]: value
        })
     
    }
    const handleChange1 = (e) => {
       // let value = e.target.nodeName === "SELECT" ? (e.target.value == "true" ? true : false) : e.target.value;
       
        setTabla1({
            ...tabla1,
            [e.target.name]: e.target.value
        })
        if (e.target.name == "telefono") {
          
            buscarCliente(e.target.value)
        }
     
    }
    const handleChange3 = (e) => {
        setTabla3({
            ...tabla3,
            [e.target.name]: e.target.value
        })
    }

    const buscarCliente = async (t) => {
        let response = await fetch(Api + "Transporte/buscarCliente/"+t);
        if (response.ok) {
            let data1 = await response.json()
            if (data1 != false) {
                setTabla1({
                    ...tabla1,
                    nombreCliente: data1.nombre, id: data1.id, direccion: data1.direccion, clienteID: data1.clienteID , telefono: t
                })
                //tabla1.nombre = data1.nombre;
                //tabla1.id = data1.id; tabla1.direccion = data1.direccion; tabla1.clienteID = data1.clienteID; tabla1.telefono= t
            }
          
        }
    }

    const ListaOrdenLinea = async (o) => {
        let response = await fetch(Api + "Transporte/ListaOrdenLinea/" + o);
        if (response.ok) {
            let data1 = await response.json()
            SetListado1(data1)
        }
    }
    const ListaResumen = async (o) => {
        let response = await fetch(Api + "Transporte/ListaResumido/" + o);
        if (response.ok) {
            let data1 = await response.json()
            SetListado2(data1)

        }
    }

    let correo = JSON.parse(user).correo;
    const obtenerDatos = async () => {
        let response = await fetch(Api + "Transporte/listaOrden" );
        if (response.ok) {
            let data = await response.json()
            SetListado(data)
            setPendiente(false)
       
           
           
        }
    }

    useEffect(() => {
        obtenerDatos();
    })


    const mostrarMensaje = () => {
        Swal.fire({
            title: 'ERROR',
            text: "No puedes guardar si hay un elemento Activo.  Favor inactivar el elemento. ",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            //confirmButtonText: 'Si, continuar',
            cancelButtonText: 'volver'
        }).then((result) => {
            //alert(result.value)
            if (result.value) {


            }
        })

    }


    const guardarCambios = async () => {
        let response;
        if (tabla.ordenID == 0) {
            tabla.creadoPor = JSON.parse(user).correo;
            response = await fetch(Api + "Transporte/GuardarOrden", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })
            setVerModal(!verModal);
        } else {
            tabla.modificadoPor = JSON.parse(user).correo;
            response = await fetch(Api + "Transporte/EditarOrden", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })
        }

        if (response.ok) {

            if (tabla.activa == false) {
                setTabla(modeloDatos);
                setVerModal(!verModal);
            }
            let data1 = await response.json()

            if (data1 == false) {
                mostrarMensaje()
            } else {
                await obtenerDatos();
                setTabla(modeloDatos)
                setVerModal(!verModal);
            }
        } else {
            alert("error al guardar")
        }

    }

    const guardarItem = async () => {
        let response;
        if (tabla1.ordenLineaID == 0) {
            tabla1.creadoPor = JSON.parse(user).correo;
            response = await fetch(Api + "Transporte/GuardarOrdenLinea", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla1)
            })
          
        } else {
            tabla1.modificadoPor = JSON.parse(user).correo;
            response = await fetch(Api + "Transporte/EditaOrdenLinea", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla1)
            })
        }

        if (response.ok) {
            ListaOrdenLinea(tabla.ordenID);

            setTabla1(modeloDatos1);
            tabla1.direccion = "";
            tabla1.id = "";
            ListaOrdenLinea(tabla1.ordenID);
            Swal.fire(
                'Guardado!',
                '' + tabla.nombre,
                'success'
            )
            if (tabla1.activa == false) {
                setTabla1(modeloDatos1);
            
            }
            let data1 = await response.json()

            if (data1 == false) {
                mostrarMensaje()
            } else {
                await ListaOrdenLinea();
                setTabla1(modeloDatos1)
             
            }
        } else {
            alert("error al guardar")
        }

    }

    const guardarCambiosArt = async () => {
        let response;
        if (tabla3.articuloID == 0) {
            tabla3.creadoPor = JSON.parse(user).correo;
            response = await fetch(Api + "Transporte/GuardarArticulos", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla3)
            })
            setVerModal3(!verModal3);
        }
        setTabla3(modeloDatos3);
        ListaResumen(tabla.ordenID);
    }


  
    const AgregarITEM = (data) => {
        setTabla(data);
        setVerModal1(!verModal1);
        ListaOrdenLinea(data.ordenID);
        tabla1.ordenID = data.ordenID;
    }

    const AgregarResumen = (data) => {
        setTabla(data);
        setVerModal2(!verModal2);
        ListaResumen(data.ordenID);
        tabla2.ordenID = data.ordenID;
    }

    const abrirEditarModal = (data) => {
        setTabla(data);
        setVerModal(!verModal);
    }
    const cerrarModal = () => {
        setTabla(modeloDatos)
        setVerModal(false)
        setVerModal1(false)
        setVerModal2(false)
    }

    const columns = [
  
        {
            name: 'Texto ',
            selector: row => row.descripcion,
            sortable: true,
        },
        {
            name: 'Placa ',
            selector: row => row.placa,
            sortable: true,
        },

      
        {
            name: 'Salida',
            selector: row => Moment(row.fechaSalida).format("DD/MM/YYYY"),
            sortable: true,

        },
        {
            name: '',
            cell: row => (
                <>
                    <Button  size="sm" className="mr-2"
                        onClick={() => abrirEditarModal(row)}
                    >
                        <i className="fas fa-pen-alt"></i>
                    </Button>

                    <Button color="primary" size="sm" className="mr-2"
                        onClick={() => AgregarITEM(row)}
                    >
                        <i className="fas fa-eye"></i>
                    </Button>

                    <Button  size="sm" className="mr-2"
                        onClick={() => AgregarResumen(row)}
                    >
                        <i className="fas fa-edit"></i>
                    </Button>

                    <Button hidden={row.obtenido == 0} color="primary" size="sm" className="mr-2"
                        href={"/ReporteVl/" + row.ordenID +"/"+row.placa} target="_bland"
                    ><i className="fas fa-print"></i></Button>

                </>
            ),
        },
    ];

    const customStyles = {
        headCells: {
            style: {
                fontSize: '13px',
                fontWeight: 800,
            },
        },
        headRow: {
            style: {
                backgroundColor: "#eee",
            }
        }
    };

    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };
    //auto completado funsiones
    const sugerenciaSeleccionada = (event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) => {

        Swal.fire({
            title: suggestion.articuloID + " - " + suggestion.descripcion,
            text: "Ingrese la cantidad",
            input: 'text',
            inputAttributes: {
                autocapitalize: 'off'
            },
            showCancelButton: true,
            confirmButtonText: 'Aceptar',
            cancelButtonText: 'Volver',
            showLoaderOnConfirm: true,
            preConfirm: (inputValue) => {


                if (isNaN(parseFloat(inputValue))) {
                    setA_Busqueda("")
                    Swal.showValidationMessage(
                        "Debe ingresar un valor númerico"
                    )
                } else {
                    

                }


            },
            allowOutsideClick: () => !Swal.isLoading()

        }).then((result) => {
            if (result.isConfirmed) {
                
                tabla2.descripcion = suggestion.descripcion;
                tabla2.articuloID = suggestion.articuloID;
                tabla2.cantidad = parseInt( result.value);
                let response;
                if (tabla2.ResumenID == 0) {
                    tabla2.creadoPor = JSON.parse(user).correo;
                    response = fetch(Api + "Transporte/GuardarResumido", {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json;charset=utf-8'
                        },
                        body: JSON.stringify(tabla2)
                    })
                    ListaResumen(tabla.ordenID); 
                };
              

                setA_Busqueda("")
            } else {
                setA_Busqueda("")
            }
        })
    }

    //para obtener la lista de sugerencias
    const onSuggestionsFetchRequested = ({ value }) => {

        const api = fetch(Api + "Transporte/ListaArticulos/" + value)
            .then((response) => {
                return response.ok ? response.json() : Promise.reject(response);
            })
            .then((dataJson) => {
                setA_Productos(dataJson)
            }).catch((error) => {
                console.log("No se pudo obtener datos, mayor detalle: ", error)
            })

    }

    //funcion que nos permite borrar las sugerencias
    const onSuggestionsClearRequested = () => {
        setA_Productos([])
    }

    //devuelve el texto que se mostrara en la caja de texto del autocomplete cuando seleccionas una sugerencia (item)
    const getSuggestionValue = (sugerencia) => {

        return sugerencia.articuloID + " - " + sugerencia.descripcion 
    }

    //como se debe mostrar las sugerencias - codigo htmlf
    const renderSuggestion = (sugerencia) => (
        <span>
            {sugerencia.articuloID +  " - " + sugerencia.descripcion}
        </span>
    )

    //evento cuando cambie el valor del texto de busqueda
    const onChange = (e, { newValue }) => {
        setA_Busqueda(newValue)
    }

    const inputProps = {
        placeholder: "Buscar Articulo",
        value: a_Busqueda,
        onChange
    }



    return (
        <>
            <Card>
                <CardHeader style={{ backgroundColor: '#4e73df', color: "white" }}>
                    Lista de Ordenes(VL)
                </CardHeader>
                <CardBody>
                    <Button color="success" size="sm"
                        onClick={() => setVerModal(!verModal)}
                    >Nueva Orden</Button>
                    <hr></hr>
                    <DataTable
                        columns={columns}
                        data={Listado}
                        progressPending={pendiente}
                        pagination
                        paginationComponentOptions={paginationComponentOptions}
                        customStyles={customStyles}
                    />
                </CardBody>
            </Card>

            <Modal  isOpen={verModal}>
                <ModalHeader className=" modal-header1">
                    Mantenimiento de Orden
                </ModalHeader>
                <ModalBody>

                    <FormGroup>
           
                                <Label>Descripcion </Label>
                                <Input bsSize="sm" name="descripcion" onChange={handleChange} value={tabla.descripcion} />
                    </FormGroup>
                    <Row>
                    <Col md={6 }>
                      <FormGroup>
                                <Label>Placa </Label>
                                <Input bsSize="sm" name="placa" onChange={handleChange} value={tabla.placa} />
                        </FormGroup> </Col>  <Col md={6}> <FormGroup>
                                <Label>Fecha Salida</Label>
                                <Input bsSize="sm" type="date" name="fechaSalida" onChange={handleChange} value={Moment(tabla.fechaSalida).format("YYYY-MM-DD")} />
                     
                    </FormGroup></Col></Row>
                   
                </ModalBody>
                <ModalFooter>
                    <Button size="sm" color="primary"
                        onClick={guardarCambios}
                    >Guardar</Button>
                    <Button size="sm" color="danger"
                        onClick={cerrarModal}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>
     
            <Modal className="modal-preguntas" isOpen={verModal1}>
                <ModalHeader className=" modal-header1">
                    Construir VL con fecha de salida {Moment(tabla.fechaSalida).format("DD-MM-YYYY") }
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <Col md="4">
                             <FormGroup>
                                <Label>Telefono</Label>
                                <ReactInputMask class="form-control" mask="999-999-9999" bsSize="sm" name="telefono" onChange={handleChange1} value={tabla1.telefono} />

                            </FormGroup>
                        </Col>
                        <Col md="8">
                            <FormGroup>

                                <Label>Nombre </Label>
                                <Input bsSize="sm" disabled value={tabla1.nombreCliente} />
                            </FormGroup></Col>
                        <Col md="6">
                            <FormGroup>
                                <Label>ID</Label>
                                <Input bsSize="sm" disabled value={tabla1.id} />

                            </FormGroup>
                        </Col>
                       
                  
                    <Col md="6">
                        <FormGroup>
                            <Label>No. Invoice</Label>
                                <Input bsSize="sm" name="no_Invoice" onChange={handleChange1}  value={tabla1.no_Invoice} />

                        </FormGroup>
                    </Col>
 <Col md="12">
                            <FormGroup>
                                <Label>Direccion</Label>
                                <Input bsSize="sm" name="direccion" onChange={handleChange1} value={tabla1.direccion} />

                            </FormGroup>
                        </Col>

                        <Col md="6">
                            <FormGroup>
                                <Label>Descripcion</Label>
                                <Input bsSize="sm" name="descripcion" onChange={handleChange1} value={tabla1.descripcion} />

                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label>Monto</Label>
                                <Input bsSize="sm" type="number" name="monto" onChange={handleChange1} value={tabla1.monto} />

                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <table class="table">
                            <tr>
                                <th>Invoice</th>
                                <th>Telefono</th>
                                <th>Nombre</th>
                                <th>Descripcion</th>
                                <th>Monto</th>

                            </tr>
                            {Listado1.map(x => <tr>
                                <td>{x.no_Invoice}</td>
                                <td>{x.telefono}</td>
                                <td>{x.nombreCliente}</td>
                                <td>{x.descripcion}</td>
                                <td>{x.monto}</td>

                            </tr>)
                            }
                        </table>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button size="sm" color="primary"
                        onClick={guardarItem}
                    >Guardar</Button>
                    <Button size="sm" color="danger"
                        onClick={cerrarModal}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>


            { /*ASIGNACION DE RESUMEN */}
            <Modal isOpen={verModal2} className="modal-preguntas" >
                <ModalHeader className=" modal-header1">
                
                  Resumen de cantidades para el flete: <b>{tabla.descripcion}</b>
                
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <Col md={8}>
                    <FormGroup>
                                <Label><h4>Buscador de Articulos </h4></Label>
                             
                                <Autosuggest
                                    suggestions={a_Productos}
                                    onSuggestionsFetchRequested={onSuggestionsFetchRequested}
                                    onSuggestionsClearRequested={onSuggestionsClearRequested}
                                    getSuggestionValue={getSuggestionValue}
                                    renderSuggestion={renderSuggestion}
                                    inputProps={inputProps}
                               onSuggestionSelected={sugerenciaSeleccionada}
                                />
                            </FormGroup>

                        </Col><Col md={2 }></Col>
                        <Col md={2}> <Button color="success" size="sm"
                            onClick={() => setVerModal3(!verModal3)}
                        >Nuevo Articulo Maestro</Button></Col>
                    </Row>
                    <br></br>
                    <Row>
                        <table class="table">
                            <tr>
                                <th>ID</th>
                                <th>Nombre</th>
                                <th>Cantidad</th>

                            </tr>
                            {Listado2.map(x => <tr>
                                <td>{x.resumenID}</td>
                                <td>{x.descripcion}</td>
                                <td>{x.cantidad}</td>

                            </tr>)
                            }
                        </table>
                    </Row>
                </ModalBody>
                <ModalFooter>
            
                    <Button size="sm" color="danger"
                        onClick={cerrarModal}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>

            {/*    Nuevo Articulo*/}

            <Modal isOpen={verModal3} >
                <ModalHeader className=" modal-header1">
                    Mantenimiento de Cliente
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <Col md="12">
                            <FormGroup>
                                <Label>Nombre </Label>
                                <Input bsSize="sm" name="descripcion" onChange={handleChange3} value={tabla3.descripcion} />
                            </FormGroup></Col>


                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button size="sm" color="primary"
                        onClick={guardarCambiosArt}
                    >Guardar</Button>
                    <Button size="sm" color="danger"
                        onClick={()=>setVerModal3(false)}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>
        </>
    )

}
export default Version;